import { render, staticRenderFns } from "./InspectionListTable.vue?vue&type=template&id=464063f7"
import script from "./InspectionListTable.vue?vue&type=script&lang=js"
export * from "./InspectionListTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports